import { defineNuxtRouteMiddleware, useRequestEvent } from '#imports'

import { updateActiveSpan } from '@backmarket/instrument/updateActiveSpan'

/**
 * Override the active span resource name with the target route name.
 */
export default defineNuxtRouteMiddleware((to) => {
  if (process.server) {
    const event = useRequestEvent()
    if (!event) return

    updateActiveSpan((span) => {
      // We can use `Array#at` here because this code runs on the server.
      const route = to.matched.at(-1) ?? to
      const path = route.path.replace(/\([a-zA-Z|-]+\)/g, '')
      const resource = `${event.node.req.method} ${path}`

      span.setAttributes({
        // dd legacy
        'resource.name': resource,
        'resource.locale': to.params?.locale ?? 'unknown',
        // otel
        'url.template': path,
      })
    })
  }
})
